import { defineMessages } from 'react-intl';

export const scope = 'app.components.transactions.transactions_table';

export default defineMessages({
  transaction_id: {
    id: `${scope}.transaction_id`,
    defaultMessage: 'Transaction ID',
  },
  drive_enrollment_id: {
    id: `${scope}.drive_enrollment_id`,
    defaultMessage: 'Drive Enrollment ID',
  },
  candidate_details: {
    id: `${scope}.candidate_details`,
    defaultMessage: 'Candidate Details',
  },
  sku: {
    id: `${scope}.sku`,
    defaultMessage: 'SKU',
  },
  transaction_action: {
    id: `${scope}.transaction_action`,
    defaultMessage: 'Transaction Action',
  },
  transaction_date: {
    id: `${scope}.transaction_date`,
    defaultMessage: 'Transaction Date',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  sku_value: {
    id: `${scope}.sku_value`,
    defaultMessage: 'SKU Value',
  },
  amount_paid: {
    id: `${scope}.amount_paid`,
    defaultMessage: 'Amount Paid',
  },
  discount_applied: {
    id: `${scope}.discount_applied`,
    defaultMessage: 'Discount Applied',
  },
  voucher_code: {
    id: `${scope}.voucher_code`,
    defaultMessage: 'Voucher Code',
  },
  country_of_residence: {
    id: `${scope}.country_of_residence`,
    defaultMessage: 'Country of Residence',
  },
  invoice_id: {
    id: `${scope}.invoice_id`,
    defaultMessage: 'Invoice ID',
  },
});
